/* House of Hez · Build Your Own Charm Set
   Reads its config from <script type="application/json" data-hz-config> inside each [data-hz-builder]. */
(function () {
  'use strict';

  // Fallback bead colors, keyed by lowercased stone name. Section blocks override these.
  var STONE_COLORS = {
    'ruby': '#9e0f2e', 'red coral': '#d23a2e', 'red carnelian': '#b9351f', 'carnelian': '#b9351f',
    'pink spinel': '#d42679', 'spinel': '#d42679', 'morganite': '#efa293', 'pink quartz': '#f3c4cf',
    'rose quartz': '#f3c4cf', 'mandarin garnet': '#f06a1a', 'peach aventurine': '#f2a57a',
    'citrine': '#eea51c', 'champagne zircon': '#d8c19c', 'lemon quartz': '#e3d332', 'peridot': '#a3b743',
    'mint variscite': '#a3dcc0', 'jade': '#2e9c5a', 'emerald': '#0e6a44', 'aquamarine': '#a6d9df',
    'blue indicolite': '#6c8ea8', 'indicolite': '#6c8ea8', 'blue apatite': '#1c9cbe', 'turquoise': '#3cc0be',
    'sapphire': '#1b3f9c', 'blue lace agate': '#b2b1db', 'amethyst': '#8a5db3', 'sunstone': '#b4632d',
    'smoky quartz': '#7a5e48', 'white moonstone': '#e7e7ec', 'moonstone': '#e7e7ec',
    "tiger's eye": '#a0682a', 'tigers eye': '#a0682a', 'tiger eye': '#a0682a', 'black onyx': '#1d1d1f', 'onyx': '#1d1d1f', 'opal': '#e9e4f0'
  };
  var METALS = {
    gold:   { hi: '#fff3c4', mid: '#d6ae55', lo: '#8c6720', ink: '#5a400f' },
    silver: { hi: '#ffffff', mid: '#bcc3ca', lo: '#737b84', ink: '#3a4048' }
  };
  var LOW_INITIAL = 'Ruby, Red Coral, Red Carnelian, Pink Spinel, Morganite, Mint Variscite, Jade, Emerald, Aquamarine, Blue Indicolite, Blue Apatite, Turquoise, Sapphire, Blue Lace Agate, Amethyst, White Moonstone';

  var LETTER_METALS = {
    gold:   { hi: '#fff3a0', mid: '#f2c81c', lo: '#c99700', edge: '#9c7400' },
    silver: { hi: '#ffffff', mid: '#d4d7da', lo: '#9ea3a8', edge: '#6f757b' }
  };
  var STORE_KEY = 'hz-charm-set:';

  function metalKey(m) { return /silver|steel|platinum/i.test(m || '') ? 'silver' : 'gold'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); }
  function hashColor(name) {
    var h = 0; for (var i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) % 360;
    return 'hsl(' + h + ',45%,55%)';
  }
  function toRgb(hex) {
    var m = /^#?([0-9a-f]{6})$/i.exec(hex || ''); if (!m) return null;
    var n = parseInt(m[1], 16); return [n >> 16, (n >> 8) & 255, n & 255];
  }
  function mix(hex, toward, t) {
    var a = toRgb(hex), b = toRgb(toward); if (!a || !b) return hex;
    return '#' + a.map(function (v, i) { var c = Math.round(v + (b[i] - v) * t); return (c < 16 ? '0' : '') + c.toString(16); }).join('');
  }
  // Dark text on light stones, white text on deep ones.
  function inkFor(hex) {
    var c = toRgb(hex); if (!c) return '#fff';
    return (0.299 * c[0] + 0.587 * c[1] + 0.114 * c[2]) > 160 ? '#2a1f24' : '#fff';
  }
  function formatMoney(cents, fmt) {
    fmt = fmt || '$' + '{' + '{amount}}';
    var n = (cents / 100);
    var withDec = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (k === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',');
      return withDec;
    }).replace(/<[^>]*>/g, '');
  }
  var uidSeq = 0;

  function Builder(root, cfg) {
    this.root = root;
    this.cfg = cfg;
    this.uid = 'hz' + (++uidSeq);
    var opts = cfg.options || [];
    function idx(name, fallback) {
      for (var i = 0; i < opts.length; i++) if ((opts[i].name || '').toLowerCase() === (name || '').toLowerCase()) return i;
      return fallback;
    }
    this.iMetal = idx(cfg.metalOption || 'Metal Color', -1);
    this.iStone = idx(cfg.stoneOption || 'Stone Color', 0);
    this.iCustom = idx(cfg.customOption || 'Customization', -1);
    this.metals = this.iMetal > -1 ? opts[this.iMetal].values : [''];
    this.stones = (opts[this.iStone] || { values: [] }).values.map(function (name, i) {
      var ov = (cfg.stoneOverrides || {})[name.toLowerCase()] || {};
      return { name: name, i: i, color: ov.color || STONE_COLORS[name.toLowerCase()] || hashColor(name), bead: ov.bead || null };
    });
    var customVals = this.iCustom > -1 ? opts[this.iCustom].values : [];
    this.noneValue = customVals[0];
    this.initialValue = customVals.filter(function (v) { return /initial|letter|monogram/i.test(v); })[0] || customVals[1];
    this.allowInitials = cfg.allowInitials !== false && this.iCustom > -1 && !!this.initialValue;
    this.allowCustom = cfg.allowCustom !== false;
    this.minSize = Math.max(1, +cfg.customMin || 2);
    this.maxSize = Math.max(this.minSize, +cfg.customMax || 20);
    var maxSize = this.maxSize;
    this.sizes = (cfg.sizes && cfg.sizes.length ? cfg.sizes : [4, 6, 8]).map(Number).filter(function (n) { return n > 0 && n <= maxSize; });
    // Set prices by size, e.g. "4:48, 6:64". Sizes in between take the best tier below them.
    // "12+:9" prices sets of 12 or more at $9 a charm.
    this.tiers = {};
    this.perCharm = null;
    var tiers = this.tiers, self0 = this;
    String(cfg.setPrices || '').split(',').forEach(function (pair) {
      var m = /^\s*(\d+)(\+?)\s*[:=]\s*\$?\s*([\d.]+)\s*$/.exec(pair);
      if (!m) return;
      if (m[2]) self0.perCharm = { from: +m[1], each: Math.round(parseFloat(m[3]) * 100) };
      else tiers[+m[1]] = Math.round(parseFloat(m[3]) * 100);
    });

    var saved = this.load();
    var okSaved = saved && (this.sizes.indexOf(saved.size) > -1 || (this.allowCustom && saved.size >= this.minSize && saved.size <= this.maxSize));
    this.size = okSaved ? saved.size : (this.sizes.indexOf(cfg.defaultSize) > -1 ? cfg.defaultSize : this.sizes[Math.floor((this.sizes.length - 1) / 2)]);
    this.custom = !!(okSaved && (saved.custom || this.sizes.indexOf(saved.size) < 0));
    // The metal picker sets the metal for the next charm; each charm keeps its own metal.
    this.metal = saved && this.metals.indexOf(saved.metal) > -1 ? saved.metal : this.metals[0];
    this.slots = [];
    for (var s = 0; s < this.size; s++) this.slots.push(null);
    var self = this;
    if (saved && saved.slots) saved.slots.slice(0, this.size).forEach(function (c, k) {
      if (c && self.stoneByName(c.stone)) self.slots[k] = { stone: c.stone, metal: self.metals.indexOf(c.metal) > -1 ? c.metal : self.metal, initial: c.initial || '' };
    });
    if (cfg.sample && !saved) cfg.sample.slice(0, this.size).forEach(function (n, k) { if (self.stoneByName(n)) self.slots[k] = { stone: n, metal: self.metal, initial: '' }; });
    this.selected = null;
    this.fresh = -1;

    this.mount();
    this.render();
  }

  Builder.prototype.stoneByName = function (n) {
    for (var i = 0; i < this.stones.length; i++) if (this.stones[i].name === n) return this.stones[i];
    return null;
  };

  Builder.prototype.variantFor = function (stone, withInitial, metal) {
    var self = this, vs = this.cfg.variants || [];
    metal = metal || this.metal;
    function match(custom) {
      for (var i = 0; i < vs.length; i++) {
        var o = vs[i].o;
        if (o[self.iStone] !== stone) continue;
        if (self.iMetal > -1 && o[self.iMetal] !== metal) continue;
        if (self.iCustom > -1 && custom != null && o[self.iCustom] !== custom) continue;
        return vs[i];
      }
      return null;
    }
    if (this.iCustom > -1) return match(withInitial ? this.initialValue : this.noneValue) || match(this.noneValue) || match(null);
    return match(null);
  };
  Builder.prototype.slotVariant = function (c) { return c ? this.variantFor(c.stone, !!c.initial, c.metal) : null; };

  Builder.prototype.countOf = function (variantId, ignoreSlot) {
    var self = this, n = 0;
    this.slots.forEach(function (c, i) { if (c && i !== ignoreSlot) { var v = self.slotVariant(c); if (v && v.id === variantId) n++; } });
    return n;
  };

  // How many more of this charm can go in the set (Infinity when inventory isn't tracked).
  Builder.prototype.room = function (stone, withInitial, metal, ignoreSlot) {
    var v = this.variantFor(stone, withInitial, metal);
    if (!v || !v.available) return 0;
    if (v.inv == null) return Infinity;
    return Math.max(0, v.inv - this.countOf(v.id, ignoreSlot));
  };

  Builder.prototype.filled = function () { return this.slots.filter(Boolean).length; };

  Builder.prototype.load = function () {
    try { var raw = window.localStorage.getItem(STORE_KEY + (this.cfg.productId || 'demo')); return raw ? JSON.parse(raw) : null; } catch (e) { return null; }
  };
  Builder.prototype.save = function () {
    try { window.localStorage.setItem(STORE_KEY + (this.cfg.productId || 'demo'), JSON.stringify({ size: this.size, custom: this.custom, metal: this.metal, slots: this.slots })); } catch (e) {}
  };

  /* ---------- drawing ---------- */

  Builder.prototype.defs = function () {
    var u = this.uid, out = '';
    this.stones.forEach(function (s) {
      if (s.bead) {
        out += '<pattern id="' + u + 'b' + s.i + '" patternContentUnits="objectBoundingBox" width="1" height="1"><image href="' + esc(s.bead) + '" width="1" height="1" preserveAspectRatio="xMidYMid slice"/></pattern>';
      } else {
        out += '<radialGradient id="' + u + 'b' + s.i + '" cx="38%" cy="32%" r="72%" fx="34%" fy="26%">' +
          '<stop offset="0" stop-color="' + mix(s.color, '#ffffff', .55) + '"/>' +
          '<stop offset=".45" stop-color="' + s.color + '"/>' +
          '<stop offset="1" stop-color="' + mix(s.color, '#000000', .38) + '"/></radialGradient>';
      }
    });
    Object.keys(METALS).forEach(function (k) {
      var m = METALS[k];
      out += '<linearGradient id="' + u + 'm' + k + '" x1="0" y1="0" x2="1" y2="1">' +
        '<stop offset="0" stop-color="' + m.hi + '"/><stop offset=".5" stop-color="' + m.mid + '"/><stop offset="1" stop-color="' + m.lo + '"/></linearGradient>';
    });
    // Cloudy veining laid over each bead so stones read as natural rather than flat plastic.
    out += '<filter id="' + u + 'veins" x="0" y="0" width="1" height="1"><feTurbulence type="fractalNoise" baseFrequency=".16" numOctaves="3" seed="11"/>' +
      '<feColorMatrix type="matrix" values="0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  0 0 0 -1.4 .78"/><feComposite in2="SourceGraphic" operator="in"/></filter>';
    out += '<filter id="' + u + 'lift" x="-50%" y="-50%" width="200%" height="200%"><feDropShadow dx="0" dy="1.5" stdDeviation="2" flood-color="#000" flood-opacity=".18"/></filter>';
    // The initial's metal, matched to the real magnetic clasps in the product photos.
    Object.keys(LETTER_METALS).forEach(function (k) {
      var m = LETTER_METALS[k];
      out += '<linearGradient id="' + u + 'l' + k + '" x1="0" y1="0" x2="0" y2="1">' +
        '<stop offset="0" stop-color="' + m.hi + '"/><stop offset=".55" stop-color="' + m.mid + '"/><stop offset="1" stop-color="' + m.lo + '"/></linearGradient>';
    });
    out += '<clipPath id="' + u + 'clip" clipPathUnits="objectBoundingBox"><circle cx=".5" cy=".5" r=".5"/></clipPath>';
    return out;
  };

  // One charm centered on 0,0 (fits a 120×120 box). rot turns the clasp; light stays top-left.
  Builder.prototype.charm = function (stone, initial, rot, metalName) {
    var u = this.uid, mk = metalKey(metalName || this.metal), metal = 'url(#' + u + 'm' + mk + ')';
    var s = this.stoneByName(stone); if (!s) return '';
    var R = 36, n = 11, br = 6.7, start = -90 + 24, span = 312, rad = Math.PI / 180;
    var out = '<circle r="' + R + '" fill="none" stroke="' + metal + '" stroke-width="1.5"/>';
    var step = span / (n - 1);
    function pt(a, r) { return [(r || R) * Math.cos(a * rad), (r || R) * Math.sin(a * rad)]; }
    function spacer(a) {
      var p = pt(a);
      return '<rect x="-5.4" y="-1.15" width="10.8" height="2.3" rx="1.1" fill="' + metal + '" transform="translate(' + p[0].toFixed(2) + ' ' + p[1].toFixed(2) + ') rotate(' + a.toFixed(1) + ')"/>';
    }
    for (var i = 0; i < n; i++) {
      var a = rot + start + step * i, p = pt(a);
      if (i === 0) out += spacer(a - step / 2 + 1.5);
      out += '<circle cx="' + p[0].toFixed(2) + '" cy="' + p[1].toFixed(2) + '" r="' + br + '" fill="url(#' + u + 'b' + s.i + ')"/>';
      if (!s.bead) out += '<circle cx="' + p[0].toFixed(2) + '" cy="' + p[1].toFixed(2) + '" r="' + br + '" fill="#fff" opacity=".55" filter="url(#' + u + 'veins)"/>';
      out += '<ellipse cx="' + (p[0] - 2.2).toFixed(2) + '" cy="' + (p[1] - 2.6).toFixed(2) + '" rx="1.9" ry="1.2" fill="#fff" opacity=".7"/>';
      out += spacer(a + step / 2 - (i === n - 1 ? 1.5 : 0));
    }
    // Magnetic clasp: two short barrels meeting at the gap.
    var c = rot - 90, cp = pt(c);
    out += '<g transform="translate(' + cp[0].toFixed(2) + ' ' + cp[1].toFixed(2) + ') rotate(' + (c + 90).toFixed(1) + ')">' +
      '<rect x="-8.6" y="-3.6" width="8" height="7.2" rx="2.2" fill="' + metal + '"/><rect x=".6" y="-3.6" width="8" height="7.2" rx="2.2" fill="' + metal + '"/>' +
      '<rect x="-.3" y="-3.2" width=".6" height="6.4" fill="' + METALS[mk].lo + '" opacity=".7"/></g>';
    if (initial) {
      out += this.letter(initial, 0, 58, 17, mk);
    }
    return out;
  };

  Builder.prototype.photo = function (stone, initial, metalName) {
    var v = this.variantFor(stone, false, metalName), mk = metalKey(metalName || this.metal);
    if (!v || !v.img) return this.charm(stone, initial, 0, metalName);
    var out = '<image href="' + esc(v.img) + '" x="-52" y="-52" width="104" height="104" preserveAspectRatio="xMidYMid slice" clip-path="url(#' + this.uid + 'clip)"/>' +
      '<circle r="52" fill="none" stroke="' + METALS[mk].mid + '" stroke-width="1.4"/>';
    if (initial) {
      // Hang the letter just under the lowest bead, measured from the photo itself; fall back to the stone list.
      var bottom = this.beadBottom(v.img), y = bottom != null ? Math.min(60, Math.max(36, bottom + 13)) : this.lowInitial(stone) ? 49 : 45;
      out += this.letter(initial, 0, y, 17, mk);
    }
    return out;
  };

  // Where the lowest bead sits in a product photo, in charm units (-52 top to 52 bottom), or null until known.
  // Reads the photo's pixels once per image; if the browser won't allow that, the letter keeps its default spot.
  Builder.prototype.beadBottom = function (url) {
    var self = this, cache = this._beads || (this._beads = {});
    if (!url) return null;
    if (url in cache) return cache[url];
    cache[url] = null;
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var W = 120, c = document.createElement('canvas');
        c.width = c.height = W;
        var g = c.getContext('2d', { willReadFrequently: true });
        g.drawImage(im, 0, 0, W, W);
        var d = g.getImageData(0, 0, W, W).data, bg = [0, 0, 0];
        [[1, 1], [W - 2, 1], [1, W - 2], [W - 2, W - 2]].forEach(function (q) {
          var i = (q[1] * W + q[0]) * 4;
          for (var k = 0; k < 3; k++) bg[k] += (d[i + 3] < 40 ? 255 : d[i + k]) / 4;
        });
        // Scan up from the bottom for the first row with a few clearly non-background pixels near the middle.
        for (var y = W - 1; y > W * .45; y--) {
          var n = 0;
          for (var x = Math.round(W * .2); x < W * .8; x++) {
            var i = (y * W + x) * 4;
            if (d[i + 3] < 40) continue;
            if (Math.abs(d[i] - bg[0]) + Math.abs(d[i + 1] - bg[1]) + Math.abs(d[i + 2] - bg[2]) > 70) n++;
          }
          if (n >= 4) { cache[url] = -52 + 104 * (y + 1) / W; break; }
        }
        if (cache[url] != null && self.slots.some(function (sl) { return sl && sl.initial; })) self.render(true);
      } catch (e) {}
    };
    im.src = url;
    return null;
  };

  // Some product photos sit lower in the frame, so their initial needs to hang a little lower to clear the beads.
  Builder.prototype.lowInitial = function (stone) {
    if (!this._low) this._low = String(this.cfg.lowInitialStones == null ? LOW_INITIAL : this.cfg.lowInitialStones).split(',').map(function (n) { return n.trim().toLowerCase(); });
    return this._low.indexOf(String(stone).toLowerCase()) > -1;
  };

  // The initial: a small solid metal letter just below the charm, no disc behind it.
  Builder.prototype.letter = function (initial, x, y, size, mk) {
    return '<text class="hz-letter" x="' + x.toFixed(2) + '" y="' + y.toFixed(2) + '" text-anchor="middle" font-size="' + size + '" fill="url(#' + this.uid + 'l' + mk + ')" stroke="' + LETTER_METALS[mk].edge + '" stroke-width="' + (size / 34).toFixed(2) + '" filter="url(#' + this.uid + 'lift)">' + esc(initial) + '</text>';
  };

  // Ring layout: biggest charms that still leave a gap between neighbours, room for the count,
  // and room under each charm for its initial (the letter reaches 76 units below the charm's center).
  Builder.prototype.layout = function (N) {
    var best = { s: 0, rr: 0 }, half = 294, inner = 62, foot = 76;
    for (var rr = 60; rr < half; rr += 2) {
      var s = Math.min(N > 1 ? (2 * rr * Math.sin(Math.PI / N) * .86) / 136 : 9, (half - rr) / foot, N > 1 ? (rr - inner) / 60 : 9);
      if (s > best.s) best = { s: s, rr: rr };
    }
    if (HAND_LAYOUTS[N]) return handLayout(HAND_LAYOUTS[N]);
    if (N >= 9) return this.layout2(N);
    var off = N === 4 ? 45 : N === 8 ? 22.5 : 0;
    var pts = [];
    for (var i = 0; i < N; i++) {
      var a = -90 + off + 360 * i / N;
      pts.push({ x: 300 + best.rr * Math.cos(a * Math.PI / 180), y: 300 + best.rr * Math.sin(a * Math.PI / 180), a: a });
    }
    return { pts: pts, s: Math.min(best.s, 1.8) };
  };

  // Sets of 13 or more sit on two rings (outer ring first), so each spot stays a good size.
  // The inner ring is turned half a step so its charms nestle between the outer ones.
  Builder.prototype.layout2 = function (N) {
    this.ringCache = this.ringCache || {};
    if (this.ringCache[N]) return this.ringCache[N];
    var half = 294, inner = 62, foot = 76, gap = 125, best = { s: 0 };
    var fit = function (r, n) { return n > 1 ? (2 * r * Math.sin(Math.PI / n) * .86) / 136 : 9; };
    for (var r1 = 100; r1 < half; r1 += 2) {
      for (var n1 = Math.ceil(N / 2); n1 <= N - 2; n1++) {
        var sA = Math.min((half - r1) / foot, fit(r1, n1));
        if (sA <= best.s) continue;
        for (var r2 = inner; r2 < r1; r2 += 2) {
          var s = Math.min(sA, (r1 - r2) / gap, (r2 - inner) / 60, fit(r2, N - n1));
          if (s > best.s) best = { s: s, r1: r1, r2: r2, n1: n1 };
        }
      }
    }
    var pts = [], ring = function (r, n, off) {
      for (var i = 0; i < n; i++) {
        var a = -90 + off + 360 * i / n;
        pts.push({ x: 300 + r * Math.cos(a * Math.PI / 180), y: 300 + r * Math.sin(a * Math.PI / 180), a: a });
      }
    };
    ring(best.r1, best.n1, 0);
    ring(best.r2, N - best.n1, 180 / (N - best.n1));
    return (this.ringCache[N] = { pts: pts, s: Math.min(best.s, 1.8) });
  };

  // Hand-tuned plates (Hez's requests). Each spot is [distance from center, angle]; angle -90 is straight up.
  // Sizes come from a fit check that keeps photos and hanging initials clear of each other and the plate edge.
  function ring(n, r, off) {
    var out = [];
    for (var i = 0; i < n; i++) out.push([r, -90 + off + 360 * i / n]);
    return out;
  }
  var HAND_LAYOUTS = {
    // Single rings, sized so each smaller set has bigger spots than the next size up.
    4: { s: 1.7, spots: ring(4, 165, 45) },
    5: { s: 1.6, spots: ring(5, 180, 0) },
    6: { s: 1.5, spots: ring(6, 187, 0) },
    7: { s: 1.42, spots: ring(7, 199, 0) },
    8: { s: 1.33, spots: ring(8, 200, 0) },
    // 1 in the middle, 4 in the corners around it, 4 at top/right/bottom/left around those.
    9: { s: 1.32, noCount: true, spots: [[0, -90], [178, -45], [178, 45], [178, 135], [178, 225], [200, -90], [200, 0], [200, 90], [200, 180]] },
    // Back to single rings for 10 to 12 (Hez, 2026-10-05); 13 and up use two rings.
    10: { s: 1.09, spots: ring(10, 217, 0) },
    11: { s: 1.03, spots: ring(11, 223, 0) },
    12: { s: 0.98, spots: ring(12, 226, 0) }
  };
  function handLayout(h) {
    return {
      s: h.s, noCount: !!h.noCount,
      pts: h.spots.map(function (sp) {
        var r = sp[0], a = sp[1];
        return { x: 300 + r * Math.cos(a * Math.PI / 180), y: 300 + r * Math.sin(a * Math.PI / 180), a: a };
      })
    };
  }

  /* ---------- DOM ---------- */

  Builder.prototype.mount = function () {
    var self = this;
    var seg = function (name, label, values, fmt, extra) {
      return '<fieldset class="hz-seg hz-seg--' + name + '"><legend class="hz-label">' + label + '</legend><div class="hz-seg__row">' +
        values.map(function (v) {
          var id = self.uid + name + String(v).replace(/\W/g, '');
          return '<input type="radio" class="hz-sr" name="' + self.uid + name + '" id="' + id + '" value="' + esc(v) + '"><label for="' + id + '">' + fmt(v) + '</label>';
        }).join('') + (extra || '') + '</div></fieldset>';
    };
    var money = function (x) { return formatMoney(x, self.cfg.moneyFormat).replace(/\.00$/, ''); };
    var custom = this.allowCustom
      ? '<span class="hz-customgrp"><input type="radio" class="hz-sr" name="' + this.uid + 'size" id="' + this.uid + 'sizecustom" value="custom"><label for="' + this.uid + 'sizecustom">Custom<small class="hz-seg__price">' + this.minSize + '–' + this.maxSize + ' charms</small></label>' +
        '<span class="hz-stepper" hidden><button type="button" data-act="dec" aria-label="One fewer charm">−</button>' +
        '<input type="number" inputmode="numeric" min="' + this.minSize + '" max="' + this.maxSize + '" data-customsize aria-label="Number of charms">' +
        '<button type="button" data-act="inc" aria-label="One more charm">+</button></span><small class="hz-seg__price hz-customprice" hidden></small></span>'
      : '';
    this.root.innerHTML =
      '<svg class="hz-defs" aria-hidden="true" focusable="false"><defs>' + this.defs() + '</defs></svg>' +
      '<div class="hz-grid">' +
        '<div class="hz-stage">' +
          '<svg class="hz-preview" viewBox="0 0 600 600" role="group" aria-label="Your charm set preview"></svg>' +
          '<div class="hz-slotbar" aria-live="polite"></div>' +
        '</div>' +
        '<div class="hz-panel">' +
          '<div class="hz-options">' +
            seg('size', 'Set size', this.sizes, function (n) { return n + ' charms<small class="hz-seg__price">' + money(self.setPrice(n)) + '</small>'; }, custom) +
            (this.iMetal > -1 && this.metals.length > 1 ? seg('metal', 'Metal', this.metals, function (m) { return '<span class="hz-dot hz-dot--' + metalKey(m) + '"></span>' + esc(m); }, '<p class="hz-note">Mix metals: tap a charm in your set to change it.</p>') : '') +
          '</div>' +
          '<div class="hz-colors"><div class="hz-colors__head"><p class="hz-label" role="heading" aria-level="3">The color collection</p>' +
            '<div class="hz-tools"><button type="button" class="hz-link" data-act="surprise">Fill the rest for me</button><button type="button" class="hz-link" data-act="clear">Start over</button></div></div>' +
            '<div class="hz-swatches" role="list"></div></div>' +
          '<div class="hz-summary">' +
            '<div class="hz-summary__count"><div class="hz-pips" aria-hidden="true"></div><p class="hz-countline"></p></div>' +
            '<dl class="hz-breakdown"></dl>' +
            '<button type="button" class="hz-add" data-act="add"></button>' +
            '<p class="hz-msg" role="status" aria-live="polite"></p>' +
          '</div>' +
        '</div>' +
      '</div>';
    this.$ = function (sel) { return self.root.querySelector(sel); };
    this.root.addEventListener('click', function (e) { self.onClick(e); });
    this.root.addEventListener('change', function (e) { self.onChange(e); });
    this.root.addEventListener('keydown', function (e) {
      var b = e.target.closest && e.target.closest('.hz-badge');
      if (b && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); b.dispatchEvent(new MouseEvent('click', { bubbles: true })); return; }
      var g = e.target.closest && e.target.closest('[data-slot]');
      if (g && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); self.pickSlot(+g.getAttribute('data-slot')); }
      if (g && (e.key === 'Delete' || e.key === 'Backspace')) { e.preventDefault(); self.remove(+g.getAttribute('data-slot')); }
    });
    this.root.addEventListener('input', function (e) {
      if (e.target.matches('[data-initial]')) {
        var v = e.target.value.replace(/[^a-z]/gi, '').slice(-1).toUpperCase();
        e.target.value = v;
        self.setInitial(self.selected, v);
      }
    });
  };

  Builder.prototype.say = function (text, tone) {
    var m = this.$('.hz-msg'); m.textContent = text || ''; m.className = 'hz-msg' + (tone ? ' hz-msg--' + tone : '');
    clearTimeout(this._msgT);
    if (text && tone !== 'keep') this._msgT = setTimeout(function () { m.textContent = ''; }, 4200);
  };

  Builder.prototype.onChange = function (e) {
    var t = e.target;
    if (t.name === this.uid + 'size') {
      if (t.value === 'custom') { this.custom = true; this.render(); var f = this.$('[data-customsize]'); if (f) { f.focus(); f.select(); } }
      else { this.custom = false; this.resize(+t.value); }
    }
    if (t.matches('[data-customsize]')) this.resizeTo(+t.value);
    if (t.name === this.uid + 'metal') { this.metal = t.value; this.render(); }
    if (t.name === this.uid + 'slotmetal') this.setMetal(this.selected, t.value);
  };

  Builder.prototype.onClick = function (e) {
    var t = e.target.closest('[data-zoom],[data-stone],[data-slot],[data-act]');
    if (!t || !this.root.contains(t)) return;
    if (t.hasAttribute('data-zoom')) return this.zoom(t.getAttribute('data-zoom'), t);
    if (t.hasAttribute('data-stone')) return this.choose(t.getAttribute('data-stone'));
    if (t.hasAttribute('data-slot')) return this.pickSlot(+t.getAttribute('data-slot'));
    var act = t.getAttribute('data-act');
    if (act === 'remove') this.remove(this.selected);
    if (act === 'clearinitial') { this.setInitial(this.selected, ''); this.render(); var f0 = this.$('[data-initial]'); if (f0) f0.focus({ preventScroll: true }); }
    if (act === 'letterpic') this.zoomLetter(t);
    if (act === 'initial') { var f = this.$('[data-initial]'); if (f) { f.focus({ preventScroll: true }); f.select(); } }
    if (act === 'done') { this.selected = null; this.render(); }
    if (act === 'clear') { this.slots = this.slots.map(function () { return null; }); this.selected = null; this.render(); this.say('Cleared. Pick a color to start your set.'); }
    if (act === 'surprise') this.surprise();
    if (act === 'add') this.addToCart();
    if (act === 'inc') this.resizeTo(this.size + 1);
    if (act === 'dec') this.resizeTo(this.size - 1);
  };

  // Up-close view of one color: the big product photo (or a large drawing), with a hover/tap magnifier.
  Builder.prototype.zoom = function (name, opener) {
    var self = this, box = this.zoomBox;
    if (!box) {
      box = this.zoomBox = document.createElement('div');
      box.className = 'hz-lightbox';
      box.hidden = true;
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-label', 'Charm close-up');
      box.innerHTML = '<div class="hz-lightbox__card">' +
        '<button type="button" class="hz-lightbox__x" data-z="close" aria-label="Close"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
        '<div class="hz-lightbox__stage"><div class="hz-lightbox__img"></div>' +
        '<button type="button" class="hz-lightbox__nav hz-lightbox__nav--prev" data-z="prev" aria-label="Previous color"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>' +
        '<button type="button" class="hz-lightbox__nav hz-lightbox__nav--next" data-z="next" aria-label="Next color"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button></div>' +
        '<div class="hz-lightbox__foot"><div><p class="hz-lightbox__name"></p><p class="hz-lightbox__sub"></p></div>' +
        '<div class="hz-lightbox__acts"><button type="button" class="hz-btn-quiet hz-lightbox__metal" data-z="metal"></button>' +
        '<button type="button" class="hz-add hz-lightbox__add" data-z="add"></button></div></div></div>';
      this.root.appendChild(box);
      box.addEventListener('click', function (e) {
        var b = e.target.closest('[data-z]');
        if (!b) { if (e.target === box) self.unzoom(); return; }
        var z = b.getAttribute('data-z');
        if (z === 'close') self.unzoom();
        if (z === 'prev' || z === 'next') self.zoomStep(z === 'next' ? 1 : -1);
        if (z === 'metal') { self.metal = self.otherMetal(); self.render(); self.zoom(self.zoomName); return; }
        if (z === 'add') { var nm = self.zoomName; self.unzoom(); self.choose(nm); }
      });
      var stage = box.querySelector('.hz-lightbox__img');
      stage.addEventListener('click', function () { stage.classList.toggle('is-mag'); });
      stage.addEventListener('mousemove', function (e) {
        var r = stage.getBoundingClientRect();
        stage.style.setProperty('--hz-zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        stage.style.setProperty('--hz-zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      });
      box.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); self.unzoom(); }
        if (e.key === 'ArrowRight') self.zoomStep(1);
        if (e.key === 'ArrowLeft') self.zoomStep(-1);
        if (e.key === 'Tab') {
          var f = box.querySelectorAll('button'), first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
    }
    if (opener) this.zoomOpener = opener;
    this.zoomName = name;
    box.classList.remove('is-letter');
    var v = this.variantFor(name, false), s = this.stoneByName(name), out = !v || !v.available;
    var img = box.querySelector('.hz-lightbox__img');
    img.classList.remove('is-mag');
    img.style.setProperty('--hz-stone', s ? s.color : '#ccc');
    img.innerHTML = v && (v.big || v.img)
      ? '<img src="' + esc(v.big || v.img) + '" alt="' + esc(name + ' wine charm in ' + this.metal.toLowerCase()) + '">'
      : '<svg viewBox="-60 -60 120 120" role="img" aria-label="' + esc(name) + '">' + this.charm(name, '', 0) + '</svg>';
    box.querySelector('.hz-lightbox__name').textContent = name;
    box.querySelector('.hz-lightbox__sub').textContent = [this.iMetal > -1 ? this.metal + ' hardware' : '', out ? 'Sold out' : ''].filter(Boolean).join(' · ');
    var flip = box.querySelector('[data-z="metal"]'), other = this.otherMetal();
    flip.hidden = !other;
    flip.textContent = other ? 'See it in ' + other : '';
    var add = box.querySelector('[data-z="add"]');
    add.disabled = out;
    // The add button wears this stone's color.
    var sc = s ? s.color : '';
    add.style.background = sc;
    add.style.color = sc ? inkFor(sc) : '';
    add.style.boxShadow = sc ? 'inset 0 0 0 1px ' + mix(sc, '#000000', .18) : '';
    add.textContent = this.selected != null && this.slots[this.selected] ? 'Swap into my set' : 'Add to my set';
    if (box.hidden) {
      box.hidden = false;
      document.documentElement.classList.add('hz-noscroll');
      box.querySelector('[data-z="close"]').focus({ preventScroll: true });
    }
  };

  // The metal the "See it in …" button switches to, when there are exactly two.
  Builder.prototype.otherMetal = function () {
    if (this.iMetal < 0 || this.metals.length !== 2) return '';
    return this.metals[0] === this.metal ? this.metals[1] : this.metals[0];
  };

  Builder.prototype.zoomStep = function (d) {
    if (this.zoomBox.classList.contains('is-letter')) return;
    var names = this.stones.map(function (s) { return s.name; });
    var i = names.indexOf(this.zoomName);
    this.zoom(names[(i + d + names.length) % names.length]);
  };

  Builder.prototype.unzoom = function () {
    if (!this.zoomBox || this.zoomBox.hidden) return;
    this.zoomBox.hidden = true;
    document.documentElement.classList.remove('hz-noscroll');
    var o = this.zoomOpener && this.root.querySelector('[data-zoom="' + (window.CSS && CSS.escape ? CSS.escape(this.zoomName) : this.zoomName) + '"]');
    if (o) o.focus({ preventScroll: true });
  };

  Builder.prototype.nextEmpty = function () {
    for (var i = 0; i < this.slots.length; i++) if (!this.slots[i]) return i;
    return -1;
  };

  Builder.prototype.choose = function (name) {
    var target = this.selected != null ? this.selected : this.nextEmpty();
    if (target < 0) { this.say('Your set of ' + this.size + ' is full. Tap a charm in your set to swap it, or choose a bigger set.', 'warn'); return; }
    var prev = this.slots[target];
    var withInitial = !!(prev && prev.initial);
    if (this.room(name, withInitial, this.metal, target) < 1) { this.say('We don’t have any more ' + name + ' in ' + this.metal.toLowerCase() + ' right now.', 'warn'); return; }
    this.slots[target] = { stone: name, metal: this.metal, initial: prev ? prev.initial : '' };
    this.fresh = target;
    if (this.selected != null) {
      this.say((prev ? prev.stone + ' swapped for ' : 'Added ') + name + '.');
      this.selected = null;
    } else {
      var left = this.size - this.filled();
      this.say(left ? name + ' added. ' + left + ' to go.' : name + ' added. Your set is complete!');
    }
    this.render();
  };

  Builder.prototype.pickSlot = function (i) {
    this.selected = this.selected === i ? null : i;
    this.render();
    // On phones the plate stays pinned while the colors scroll, so bring the charm's controls back into view.
    var bar = this.$('.hz-slotbar');
    if (this.selected != null && this.slots[this.selected] && bar && window.matchMedia('(max-width: 820px)').matches) {
      var r = bar.getBoundingClientRect(), top = parseFloat(getComputedStyle(bar).scrollMarginTop) || 0;
      if (r.top < top || r.bottom > window.innerHeight) bar.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  Builder.prototype.remove = function (i) {
    if (i == null || !this.slots[i]) return;
    var name = this.slots[i].stone;
    this.slots[i] = null;
    this.selected = null;
    this.say(name + ' removed.');
    this.render();
  };

  // Once a charm has an initial: a photo of that real letter in the charm's metal, and a way to take it off.
  Builder.prototype.letterImg = function (letter, metal) {
    var pat = this.cfg.initialImg;
    return pat && /^[A-Z]$/.test(letter) ? pat.replace('METAL', metalKey(metal)).replace('LETTER', letter.toLowerCase()) : '';
  };

  Builder.prototype.letterPhoto = function (c) {
    var src = c && c.initial ? this.letterImg(c.initial, c.metal) : '';
    return src ? '<button type="button" class="hz-letterphoto__btn" data-act="letterpic" aria-label="' + esc('Enlarge the ' + c.initial + ' initial in ' + c.metal.toLowerCase()) + '"><img src="' + esc(src) + '" alt="' + esc('The ' + c.initial + ' initial in ' + c.metal.toLowerCase()) + '" width="860" height="860"></button>' : '';
  };

  Builder.prototype.initialBits = function (c) {
    return c && c.initial ? '<button type="button" class="hz-btn-remove" data-act="clearinitial"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>Remove initial</button>' : '';
  };

  Builder.prototype.zoomLetter = function (opener) {
    var c = this.selected != null && this.slots[this.selected]; if (!c || !c.initial) return;
    this.zoom(c.stone, opener);
    var box = this.zoomBox;
    box.classList.add('is-letter');
    box.querySelector('.hz-lightbox__img').innerHTML = '<img src="' + esc(this.letterImg(c.initial, c.metal)) + '" alt="' + esc('The letter ' + c.initial + ' charm in ' + c.metal.toLowerCase()) + '">';
    box.querySelector('.hz-lightbox__name').textContent = 'Initial ' + c.initial;
    box.querySelector('.hz-lightbox__sub').textContent = c.metal;
  };

  Builder.prototype.setInitial = function (i, letter) {
    var c = i != null && this.slots[i]; if (!c) return;
    if (letter && this.room(c.stone, true, c.metal, i) < 1) { this.say('That color isn’t available with an initial in ' + c.metal.toLowerCase() + ' right now.', 'warn'); return; }
    c.initial = letter;
    this.render(true);
  };

  // Each charm's initial is made in that charm's own metal, so changing the metal carries the initial with it.
  Builder.prototype.setMetal = function (i, metal) {
    var c = i != null && this.slots[i]; if (!c || c.metal === metal) return;
    if (this.room(c.stone, !!c.initial, metal, i) < 1) { this.say(c.stone + ' isn’t available in ' + metal.toLowerCase() + ' right now.', 'warn'); this.render(); return; }
    c.metal = metal;
    this.say(c.stone + ' changed to ' + metal.toLowerCase() + '.');
    this.render();
  };

  Builder.prototype.resize = function (n) {
    var kept = this.slots.filter(Boolean), dropped = Math.max(0, kept.length - n);
    this.size = n;
    this.slots = [];
    for (var i = 0; i < n; i++) this.slots.push(kept[i] || null);
    this.selected = null;
    this.say(dropped ? 'Set of ' + n + ' selected. The last ' + dropped + ' charm' + (dropped > 1 ? 's were' : ' was') + ' removed to fit.' : 'Set of ' + n + ' selected.', dropped ? 'warn' : '');
    this.render();
  };

  Builder.prototype.resizeTo = function (n) {
    n = Math.round(n);
    if (!(n >= this.minSize)) n = this.minSize;
    if (n > this.maxSize) { n = this.maxSize; this.say('Custom sets go up to ' + n + ' charms.', 'warn'); }
    if (n === this.size) { this.render(); return; }
    this.resize(n);
  };

  Builder.prototype.surprise = function () {
    var self = this, used = {}, added = 0;
    this.slots.forEach(function (c) { if (c) used[c.stone] = 1; });
    var fits = function (s) { return self.room(s.name, false, self.metal) > 0; };
    var pool = this.stones.filter(function (s) { return !used[s.name] && fits(s); }).map(function (s) { return s.name; });
    if (!pool.length) pool = this.stones.filter(fits).map(function (s) { return s.name; });
    for (var i = 0; i < this.slots.length && pool.length; i++) {
      if (this.slots[i]) continue;
      var pick = pool.splice(Math.floor(Math.random() * pool.length), 1)[0];
      if (this.room(pick, false, this.metal) < 1) { i--; continue; }
      this.slots[i] = { stone: pick, metal: this.metal, initial: '' }; added++;
    }
    this.selected = null;
    this.fresh = -2;
    this.say(added ? 'Added ' + added + ' colors. Tap any charm to swap it.' : 'Your set is already full.');
    this.render();
  };

  // Price of one plain charm (the most common plain variant price).
  Builder.prototype.unitPrice = function () {
    if (this._unit != null) return this._unit;
    var self = this, seen = {}, best = 0, unit = 0;
    (this.cfg.variants || []).forEach(function (v) {
      if (self.iCustom > -1 && v.o[self.iCustom] !== self.noneValue) return;
      seen[v.price] = (seen[v.price] || 0) + 1;
      if (seen[v.price] > best) { best = seen[v.price]; unit = v.price; }
    });
    return (this._unit = unit);
  };

  // Set price for n charms: the listed price for that size, or the best listed saving below it.
  Builder.prototype.setPrice = function (n) {
    var unit = this.unitPrice(), tiers = this.tiers, save = 0;
    if (this.perCharm && n >= this.perCharm.from) return this.perCharm.each * n;
    if (tiers[n] != null) return tiers[n];
    Object.keys(tiers).forEach(function (k) { if (+k <= n) save = Math.max(save, unit * k - tiers[k]); });
    return Math.max(0, unit * n - save);
  };

  Builder.prototype.totals = function () {
    var self = this, extra = 0, initials = 0, N = this.size;
    this.slots.forEach(function (c) {
      if (!c) return;
      if (c.initial) { initials++; extra += self.initialExtra(c); }
    });
    var base = this.setPrice(N);
    return { base: base, total: base + extra, extra: extra, initials: initials, save: Math.max(0, this.unitPrice() * N - base) };
  };

  Builder.prototype.initialExtra = function (c) {
    var plain = this.variantFor(c.stone, false, c.metal), withI = this.variantFor(c.stone, true, c.metal);
    return plain && withI ? Math.max(0, withI.price - plain.price) : 0;
  };

  Builder.prototype.render = function (light) {
    var self = this, cfg = this.cfg, N = this.size, L = this.layout(N), u = this.uid;
    var filled = this.filled();

    // Preview: the plate, the count, the charms, then the selected charm's controls on top.
    var svg = '<circle cx="300" cy="300" r="298" class="hz-plate"/>' + (L.noCount ? '' :
      '<text x="300" y="300" text-anchor="middle" class="hz-center-num">' + filled + ' / ' + N + '</text>' +
      '<text x="300" y="322" text-anchor="middle" class="hz-center-cap">' + (filled === N ? 'set complete' : 'charms chosen') + '</text>');
    var overlay = '';
    L.pts.forEach(function (p, i) {
      var c = self.slots[i], sel = self.selected === i;
      if (c && cfg.previewStyle === 'photo') { var pv = self.variantFor(c.stone, false, c.metal); if (pv) self.beadBottom(pv.img); }
      var label = c ? 'Charm ' + (i + 1) + ': ' + c.stone + ', ' + c.metal + (c.initial ? ', initial ' + c.initial : '') + '. Press to add an initial, change metal, swap or remove it.' : 'Empty spot ' + (i + 1) + '. Press to fill this spot next.';
      svg += '<g class="hz-slot' + (sel ? ' is-selected' : '') + (c ? '' : ' is-empty') + (self.fresh === i || (self.fresh === -2 && c) ? ' is-new' : '') + '" data-slot="' + i + '" tabindex="0" role="button" aria-pressed="' + sel + '" aria-label="' + esc(label) + '" transform="translate(' + p.x.toFixed(1) + ' ' + p.y.toFixed(1) + ') scale(' + L.s.toFixed(3) + ')">' +
        '<circle r="60" class="hz-hit"/>' +
        (sel ? '<circle r="57" class="hz-ring"/>' : '') +
        '<g class="hz-charm">' + (c ? (cfg.previewStyle === 'photo' ? self.photo(c.stone, c.initial, c.metal) : self.charm(c.stone, c.initial, p.a + 90, c.metal)) :
          '<circle r="36" class="hz-ghost"/><text y="6" text-anchor="middle" class="hz-ghost-num">' + (i + 1) + '</text>') + '</g></g>';
      if (sel && c) {
        // Badges sit at a fixed on-screen size so they stay tappable even in a set of 12.
        var k = L.s, rx = p.x + 40 * k, ry = p.y - 40 * k, ix = p.x + 40 * k, iy = p.y + 40 * k;
        var pw = self.$('.hz-preview').getBoundingClientRect().width || 600, bs = Math.min(1.9, Math.max(1, 520 / pw)).toFixed(2);
        var extra = self.initialExtra(c), tip = c.initial ? 'Change initial' : 'Add initial';
        // Hover labels are drawn here (not native tooltips) so they appear the moment the pointer arrives.
        // A label goes to the right of its badge, away from the charm; near the plate's edge it drops below (or above) the badge instead.
        var tipBox = function (text, x, y, alt) {
          var tw = text.length * 7.6 + 24, fits = x + (tw + 20) * bs <= 598;
          return '<g class="hz-tip" aria-hidden="true" transform="translate(' + (fits ? '20 0' : (13 - tw).toFixed(1) + ' ' + alt) + ')"><rect x="0" y="-15" width="' + tw.toFixed(0) + '" height="30" rx="7"/><text x="' + (tw / 2).toFixed(1) + '" y="4.8" text-anchor="middle">' + esc(text) + '</text></g>';
        };
        overlay += '<g class="hz-badge hz-badge--remove" data-act="remove" role="button" tabindex="0" aria-label="Remove this charm" transform="translate(' + rx.toFixed(1) + ' ' + ry.toFixed(1) + ') scale(' + bs + ')">' +
          tipBox('Remove charm', rx, ry, -34) + '<circle r="13" filter="url(#' + u + 'lift)"/><path d="M-4-4 4 4M4-4-4 4"/></g>';
        if (self.allowInitials) {
          overlay += '<g class="hz-badge hz-badge--initial" data-act="initial" role="button" tabindex="0" aria-label="' + esc(tip) + '" transform="translate(' + ix.toFixed(1) + ' ' + iy.toFixed(1) + ') scale(' + bs + ')">' +
            (c.initial ? '' : tipBox(tip, ix, iy, 34)) + '<circle r="13" filter="url(#' + u + 'lift)"/>' +
            (c.initial ? '<text class="hz-badge__letter" y="5" text-anchor="middle">' + esc(c.initial) + '</text>' : '<text class="hz-badge__letter" x=".5" y="5" text-anchor="middle"><tspan class="hz-badge__plus" dy="-.5">+</tspan><tspan dy=".5">A</tspan></text>') + '</g>';
        }
      }
    });
    this.$('.hz-preview').innerHTML = svg + overlay;
    this.fresh = -1;

    // Selected-charm bar
    var bar = this.$('.hz-slotbar'), sc = this.selected != null ? this.slots[this.selected] : null;
    var arrow = '<svg class="hz-arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20V5M5 11l7-7 7 7"/></svg>';
    if (this.selected == null) {
      bar.innerHTML = filled
        ? '<p class="hz-hint hz-hint--cta">' + arrow + '<span>Tap a charm in your set to ' + (this.allowInitials ? '<strong>add an initial</strong>, ' : '') + '<strong>swap</strong> or <strong>remove</strong> it</span></p>'
        : '<p class="hz-hint">Pick colors from the collection. Each one joins your set here.</p>';
    } else if (!sc) {
      bar.innerHTML = '<p class="hz-hint"><strong>Spot ' + (this.selected + 1) + '</strong> is selected. Pick a color to fill it. <button type="button" class="hz-link" data-act="done">Cancel</button></p>';
    } else if (!light || !bar.querySelector('[data-initial]')) {
      var st = this.stoneByName(sc.stone), extra = this.initialExtra(sc);
      var metalPick = this.iMetal > -1 && this.metals.length > 1
        ? '<div class="hz-minseg" role="radiogroup" aria-label="Metal for this charm">' + this.metals.map(function (m) {
            var id = u + 'sm' + String(m).replace(/\W/g, '');
            return '<input type="radio" class="hz-sr" name="' + u + 'slotmetal" id="' + id + '" value="' + esc(m) + '"' + (m === sc.metal ? ' checked' : '') + '><label for="' + id + '"><span class="hz-dot hz-dot--' + metalKey(m) + '"></span>' + esc(m) + '</label>';
          }).join('') + '</div>'
        : '';
      bar.innerHTML = '<div class="hz-selbar" style="--hz-stone:' + st.color + ';--hz-stone-ink:' + inkFor(st.color) + '">' +
        '<p class="hz-selbar__name">' + esc(sc.stone) + '</p>' +
        '<div class="hz-selbar__actions">' + metalPick +
        (this.allowInitials ? '<label class="hz-initial" for="' + u + 'initial"><span>Add an initial' + (extra ? ' <em>+' + formatMoney(extra, cfg.moneyFormat).replace(/\.00$/, '') + '</em>' : '') + '</span><input type="text" inputmode="text" autocomplete="off" maxlength="1" placeholder="A" data-initial id="' + u + 'initial" value="' + esc(sc.initial) + '"></label><span class="hz-initbits">' + this.initialBits(sc) + '</span>' : '') +
        '<button type="button" class="hz-btn-remove" data-act="remove"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>Remove charm</button>' +
        '</div>' +
        (this.allowInitials ? '<div class="hz-letterphoto">' + this.letterPhoto(sc) + '</div>' : '') +
        '<p class="hz-selbar__tip">' + (this.allowInitials ? 'The initial is made in this charm’s metal. ' : '') + '<button type="button" class="hz-link" data-act="done">Done</button></p></div>';
    }

    if (light && sc && bar.querySelector('[data-initial]')) { var ib = bar.querySelector('.hz-initbits'); if (ib) ib.innerHTML = this.initialBits(sc); var lp = bar.querySelector('.hz-letterphoto'); if (lp) lp.innerHTML = this.letterPhoto(sc); }

    // Swatches show the metal that the next charm will be made in.
    var counts = {};
    this.slots.forEach(function (c) { if (c) counts[c.stone] = (counts[c.stone] || 0) + 1; });
    this.$('.hz-swatches').innerHTML = this.stones.map(function (s) {
      var v = self.variantFor(s.name, false), out = !v || !v.available, n = counts[s.name] || 0;
      var media = cfg.swatchStyle !== 'illustrated' && v && v.img
        ? '<img src="' + esc(v.img) + '" alt="" loading="lazy" width="200" height="200">'
        : '<svg viewBox="-60 -60 120 120" aria-hidden="true">' + self.charm(s.name, '', 0) + '</svg>';
      return '<div role="listitem" class="hz-swi"><button type="button" class="hz-sw' + (n ? ' is-in' : '') + '" data-stone="' + esc(s.name) + '"' + (out ? ' disabled' : '') +
        ' aria-label="' + esc(s.name + (out ? ', sold out' : n ? ', ' + n + ' in your set' : '')) + '">' +
        '<span class="hz-sw__media" style="--hz-stone:' + s.color + '">' + media + (n ? '<span class="hz-sw__n">× ' + n + '</span>' : '') + '</span>' +
        '<span class="hz-sw__name">' + esc(s.name) + '</span>' + (out ? '<span class="hz-sw__out">Sold out</span>' : '') + '</button>' +
        '<button type="button" class="hz-zoombtn" data-zoom="' + esc(s.name) + '" aria-label="See ' + esc(s.name) + ' up close"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6"/><path d="M15 15l5 5M10.5 8v5M8 10.5h5"/></svg></button></div>';
    }).join('');

    // Options
    this.root.querySelectorAll('input[name="' + u + 'size"]').forEach(function (r) { r.checked = r.value === 'custom' ? self.custom : !self.custom && +r.value === N; });
    var stepper = this.$('.hz-stepper');
    if (stepper) {
      stepper.hidden = !this.custom;
      stepper.parentNode.classList.toggle('is-on', this.custom);
      var cs = this.$('[data-customsize]'); if (document.activeElement !== cs || +cs.value !== N) cs.value = N;
      stepper.querySelector('[data-act="dec"]').disabled = N <= this.minSize;
      stepper.querySelector('[data-act="inc"]').disabled = N >= this.maxSize;
      var cp = this.$('.hz-customprice');
      cp.hidden = !this.custom;
      cp.textContent = formatMoney(this.setPrice(N), cfg.moneyFormat).replace(/\.00$/, '');
    }
    this.root.querySelectorAll('input[name="' + u + 'metal"]').forEach(function (r) { r.checked = r.value === self.metal; });

    // Summary
    var pips = '';
    for (var i = 0; i < N; i++) { var c = this.slots[i]; pips += '<span class="hz-pip' + (c ? ' is-on' : '') + '"' + (c ? ' style="--hz-stone:' + this.stoneByName(c.stone).color + '"' : '') + '></span>'; }
    this.$('.hz-pips').innerHTML = pips;
    var left = N - filled, t = this.totals(), m = function (x) { return formatMoney(x, cfg.moneyFormat); };
    this.$('.hz-countline').textContent = filled + ' of ' + N + ' charms selected';
    this.$('.hz-breakdown').innerHTML =
      '<div><dt>Base set (' + N + (N === 1 ? ' charm' : ' charms') + ')</dt><dd>' + m(t.base) + '</dd></div>' +
      (t.initials ? '<div><dt>Initials (' + t.initials + ')</dt><dd>+' + m(t.extra) + '</dd></div>' : '') +
      '<div class="hz-breakdown__total"><dt>Total</dt><dd>' + m(t.total) + '</dd></div>';
    var btn = this.$('.hz-add');
    btn.disabled = left > 0 || this.busy;
    btn.textContent = this.busy ? 'Adding…' : left > 0 ? 'Choose ' + left + ' more charm' + (left > 1 ? 's' : '') : 'Add set to cart';
    this.save();
  };

  Builder.prototype.lineItems = function () {
    var self = this, N = this.size, setId = 'S' + Date.now().toString(36).toUpperCase().slice(-5);
    var metals = {}; this.slots.forEach(function (c) { metals[c.metal] = 1; });
    var mlist = Object.keys(metals).filter(Boolean);
    var label = 'Custom set of ' + N + (mlist.length === 1 ? ' (' + mlist[0] + ')' : mlist.length > 1 ? ' (mixed metals)' : '') + ' #' + setId;
    return this.slots.map(function (c, i) {
      var props = { 'Set': label, 'Position': (i + 1) + ' of ' + N };
      if (c.initial) props['Initial'] = c.initial;
      return { id: self.slotVariant(c).id, quantity: 1, properties: props };
    });
  };

  Builder.prototype.addToCart = function () {
    if (this.filled() < this.size || this.busy) return;
    var self = this, items = this.lineItems(), cfg = this.cfg;
    if (cfg.demo) { cfg.demo(items, this); return; }
    this.busy = true; this.render();
    fetch(cfg.cartAddUrl || '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('hz:set-added', { detail: { items: items } }));
        try { window.localStorage.removeItem(STORE_KEY + (cfg.productId || 'demo')); } catch (e) {}
        if (cfg.afterAdd === 'stay') {
          self.busy = false; self.slots = self.slots.map(function () { return null; }); self.render();
          self.say('Your set is in the cart. ', 'keep');
          self.$('.hz-msg').insertAdjacentHTML('beforeend', '<a href="' + esc(cfg.cartUrl || '/cart') + '">View cart</a>');
        } else {
          window.location.href = cfg.cartUrl || '/cart';
        }
      })
      .catch(function (err) {
        self.busy = false; self.render();
        self.say((err && (err.description || err.message)) || 'Something went wrong adding your set. Please try again.', 'warn');
      });
  };

  function boot(scope) {
    (scope || document).querySelectorAll('[data-hz-builder]').forEach(function (root) {
      if (root.__hz) return;
      var json = root.querySelector('script[data-hz-config]');
      var cfg = json ? JSON.parse(json.textContent) : (window.HZ_DEMO_CONFIG || {});
      root.__hz = new Builder(root.querySelector('.hz-app') || root, cfg);
    });
  }
  window.HouseOfHezBuilder = { boot: boot, Builder: Builder };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  // Re-init when the theme editor reloads the section.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
